import { CSSProperties, ReactNode } from 'react';
import { Tooltip as TooltipPrimitive } from 'radix-ui';
import { breakpoints } from 'styles';
import { useReduxState } from 'hooks';

interface Props {
  children: ReactNode;
  childrenWrapInDiv?: boolean;
  content: ReactNode;
  contentStyle?: CSSProperties;
  isLight?: boolean;
  usePortal?: boolean;
}

const Tooltip = ({
  children,
  childrenWrapInDiv = true,
  content,
  contentStyle,
  isLight,
  usePortal
}: Props) => {
  const { theme } = useReduxState();

  const ContentWrapper = ({ children }) =>
    usePortal ? (
      <TooltipPrimitive.Portal>{children}</TooltipPrimitive.Portal>
    ) : (
      children
    );

  return !content ? (
    <>{children}</>
  ) : (
    <TooltipPrimitive.Root delayDuration={100} defaultOpen={false}>
      <TooltipPrimitive.Trigger asChild={true}>
        {childrenWrapInDiv ? <div>{children}</div> : children}
      </TooltipPrimitive.Trigger>
      <ContentWrapper>
        <TooltipPrimitive.Content
          side="top"
          align="center"
          className={`vuo-tooltip-content${isLight ? '-light' : ''}`}
          style={contentStyle}
        >
          {content}
          <TooltipPrimitive.Arrow
            offset={5}
            width={11}
            height={5}
            className={`vuo-tooltip-arrow${isLight ? '-light' : ''}`}
          />
        </TooltipPrimitive.Content>
      </ContentWrapper>

      <style jsx global>{`
        .vuo-tooltip-content {
          background-color: #333;
          border-radius: 5px;
          color: #fff;
          font-size: 1.3rem;
          font-weight: 600;
          max-width: 280px;
          padding: 4px 8px;
          white-space: normal;
          z-index: 5;
        }
        .vuo-tooltip-content-light {
          background-color: #fff;
          border-radius: 10px;
          box-shadow: rgb(255, 255, 255) 0px 0px 0px 0px,
            rgba(0, 0, 0, 0.05) 0px 0px 0px 1px,
            rgba(0, 0, 0, 0.1) 0px 10px 15px -3px,
            rgba(0, 0, 0, 0.05) 0px 4px 6px -2px;
          color: ${theme.textColor};
          font-size: 1.3rem;
          font-weight: 600;
          max-width: 280px;
          padding: 4px 8px;
          white-space: normal;
          z-index: 5;
        }
        .vuo-tooltip-arrow {
          fill: #333;
        }
        .vuo-tooltip-arrow-light {
          fill: #fff;
        }
        @media (min-width: ${breakpoints.small}px) {
          .vuo-tooltip-content,
          .vuo-tooltip-content-light {
            max-width: 480px;
          }
        }
      `}</style>
    </TooltipPrimitive.Root>
  );
};

export default Tooltip;
